import * as Bixby from '$/core';

export abstract class ClientService {
  private static baseUrl = Bixby.Constants.API_CLIENTCONTROLLER;

  public static async getCompanyRemovals(): Promise<Bixby.Models.ClientCompanyRemoval[]> {
    const route = Bixby.API.ServerRoute.forAction(`${ClientService.baseUrl}/removals`);
    return await Bixby.API.get(route);
  }

  public static async getDataSites(): Promise<Bixby.Models.ClientDataSiteForClient[]> {
    const route = Bixby.API.ServerRoute.forAction(`${ClientService.baseUrl}/datasites`);
    return await Bixby.API.get(route);
  }
  public static async getMnpiDataSites(): Promise<Bixby.Models.ClientDataSiteForClient[]> {
    const route = Bixby.API.ServerRoute.forAction(`${ClientService.baseUrl}/mnpi-datasites`);
    return await Bixby.API.get(route);
  }
}
